import http from '../../plugins/http';
const state = {
  shownStage: 'outline',
  entryGuideShown: false,
  popoverShown: false,
  tutorials: [],
  openedTutorialId: null
}

const getters = {
  shownStage: state => state.shownStage,
  entryGuideShown: state => state.entryGuideShown,
  popoverShown: state => state.popoverShown,
  tutorials: state => state.tutorials,
  openedTutorial: (state) => {
    return state.tutorials && state.tutorials.length && state.tutorials.find(v => v.id === state.openedTutorialId);
  }
}

const mutations = {
  setShownStage (state, name) {
    state.shownStage = name;
  },
  setEntryGuideShown (state, flag) {
    state.entryGuideShown = flag;
  },
  setPopoverShown (state, flag) {
    state.popoverShown = flag;
  }
}

const actions = {
  async fetchTutorial ({state}) {
    const resp = await http.get('/api/common/course?type=2&show=2');
    state.tutorials = resp.data.data;
  },
  openTutorial ({state}, {id} = {}) {
    state.openedTutorialId = id;
    state.shownStage = 'tutorialContent';
  },
  closeTutorial () {
    state.openedTutorialId = null;
    state.shownStage = 'tutorialTitle';
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/helpCenter.js